import { useEffect, useState } from "react";

interface VideosProps {
  iframe: string;
}

export default function Videos({ iframe }: VideosProps) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    const match = iframe.match(/src="([^"]+)"/);
    if (match) {
      setSrc(match[1]);
    }
  }, [iframe]);

  if (!src) return null;

  return (
    <div style={containerStyle}>
      <iframe
        src={src}
        title="YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={iframeStyle}
      ></iframe>
    </div>
  );
}

// CSS-in-JS styles
const containerStyle: React.CSSProperties = {
  position: "relative",
  paddingBottom: "56.25%", // 16:9 aspect ratio
  height: 0,
  overflow: "hidden",
  width: "100%",
  marginBottom: "1rem",
};

const iframeStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  border: "none",
};
